import { render } from "./RuiHealth.vue?vue&type=template&id=35d767fc"
const script = {}
script.render = render

export default script